import React from "react";
import Callout from "web/react/components/callout/callout";
import SVGIcon from "web/react/components/svg-icon/svg-icon";
import { useClickTracker } from "web/react/hooks/use-click-tracker/use-click-tracker";
import { gettext } from "web/script/modules/django-i18n";
import { getUrl } from "web/script/routing/getUrl";
// eslint-disable-next-line css-modules/no-unused-class
import styles from "./pre-header-bar.module.css";

function HelpDropdown(): React.ReactElement {
    const trackClickHelpCenter = useClickTracker("nav", "clicked", "help_center");
    const trackClickContactUs = useClickTracker("nav", "clicked", "contact_us");
    const trackClickAboutUs = useClickTracker("nav", "clicked", "about_us");
    const trackClickCareers = useClickTracker("nav", "clicked", "careers");

    return (
        <Callout className={styles.action}>
            <Callout.CTA>
                <div className={styles.actionContainer}>
                    {gettext("header.help")}
                    <SVGIcon className={styles.chevronIcon} name="chevron" />
                </div>
            </Callout.CTA>
            <Callout.Content>
                <ul className="app-header-dropdown-list">
                    <li className={styles.dropdownListItem}>
                        <a
                            className={styles.dropdownListItemContent}
                            href={getUrl("helpCentreHomepage")}
                            onClick={trackClickHelpCenter}
                        >
                            {gettext("header.help.help_center")}
                        </a>
                    </li>
                    <li className={styles.dropdownListItem}>
                        <a
                            className={styles.dropdownListItemContent}
                            href={getUrl("helpContactUs")}
                            onClick={trackClickContactUs}
                        >
                            {gettext("header.help.contact_us")}
                        </a>
                    </li>
                    <li className={styles.dropdownListItem}>
                        <a
                            className={styles.dropdownListItemContent}
                            href="/about/"
                            onClick={trackClickAboutUs}
                        >
                            {gettext("header.help.about_us")}
                        </a>
                    </li>
                    <li className={styles.dropdownListItem}>
                        <a
                            className={styles.dropdownListItemContent}
                            href="/careers/"
                            onClick={trackClickCareers}
                        >
                            {gettext("header.help.careers")}
                        </a>
                    </li>
                </ul>
            </Callout.Content>
        </Callout>
    );
}

export default HelpDropdown;
